import { isDefined } from "#/frontend-utils/types/runtime-type-utils";
import { matchesNameSearch } from "#/frontend-utils/utils/string-utils";

export function* walkTreeByLevel<T extends { children: Iterable<T> | undefined }>(
  roots: T | T[] | undefined,
): Generator<T> {
  let queue: T[] = [];

  if (Array.isArray(roots)) queue = [...roots];
  else if (isDefined(roots)) queue = [roots];

  let i = 0;

  while (i < queue.length) {
    const node = queue[i++]!;
    yield node;

    for (const child of node.children ?? []) {
      queue.push(child);
    }
  }
}

export function filterTreeByStringQuery<T extends { children: T[] }>(
  nodes: T[],
  query: string,
  nodeCb: (node: T) => string,
): T[] {
  if (query.length === 0) return nodes;

  return nodes.flatMap((node) => {
    if (matchesNameSearch(nodeCb(node), query)) return [node];

    const children = filterTreeByStringQuery(node.children ?? [], query, nodeCb);
    return children.length > 0 ? [{ ...node, children }] : [];
  });
}
